{
    "ModalTitleStatusChange": "ACD-Agent-Anmeldung",
    "LocationStatusTitle": "Ort",
    "LocationStatusDescription": "Wählen Sie ein Gerät und einen ACD-Agenten für die Anmeldung aus.",
    "StatusOptionsTitle": "Optionen",
    "AcdGroupOptionsDescription": "Wenn der Zieltelefonserver dies unterstützt, können Sie die ACD-Gruppe auswählen, für die der ausgewählte ACD-Status speziell geändert wird.",
    "AcdGroupLabel": "ACD-Gruppe",
    "AcdAgentLabel": "ACD-Agent",
    "FooterButtonOk": "OK",
    "FooterButtonCancel": "Absagen",
    "FooterButtonHelp": "Hilfe",
    "StatusChange_PromptMessage": "Alle Konfigurationen gehen beim Schließen verloren. Möchten Sie dieses Fenster wirklich schließen?",
    "StatusChange_PromptConfirm": "Ja",
    "StatusChange_PromptCancel": "Absagen",
    "StatusChange_DevicesLabel": "Gerät",
    "NAME": "StatusChange"
}